import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6969076c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper p-1 p-md-3" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card relative" }
const _hoisted_4 = {
  key: 0,
  class: "overlay-wrapper"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Intervention festlegen")
], -1))
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Ganztätig", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Innerhalb der Anwesenheitszeiten", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Außerhalb der Anwesenheitszeiten", -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 col-lg-6 px-lg-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }, " Verfügbare Kontaktmöglichkeiten ", -1))
const _hoisted_17 = {
  key: 0,
  class: "alert alert-info d-flex flex-column justify-content-center flex-xl-row"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-italic" }, "Sie haben noch keine Kontaktpersonen hinterlegt", -1))
const _hoisted_19 = {
  key: 1,
  class: "alert alert-info d-flex flex-column justify-content-center flex-xl-row"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-italic" }, "Sie haben noch keine Kontaktperson im Objekt hinterlegt", -1))
const _hoisted_21 = { class: "mr-3 align-self-center" }
const _hoisted_22 = { class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon" }
const _hoisted_23 = { class: "media-body align-self-center" }
const _hoisted_24 = { class: "font-weight-bold" }
const _hoisted_25 = {
  key: 0,
  class: "d-flex flex-column text-muted"
}
const _hoisted_26 = {
  key: 1,
  class: "d-flex flex-column text-muted"
}
const _hoisted_27 = { class: "media-right align-self-center mr-1" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "col-12 col-lg-6 px-lg-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }, " Kontaktreihenfolge ", -1))
const _hoisted_33 = { class: "media bg-white" }
const _hoisted_34 = { class: "mr-3 align-self-center" }
const _hoisted_35 = { class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon" }
const _hoisted_36 = { class: "media-body align-self-center" }
const _hoisted_37 = { class: "font-weight-bold" }
const _hoisted_38 = {
  key: 0,
  class: "d-flex flex-column text-muted"
}
const _hoisted_39 = {
  key: 1,
  class: "d-flex flex-column text-muted"
}
const _hoisted_40 = { class: "media-right align-self-center mr-1" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "card-footer text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.shouldDisableInterventionChanges())
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", null, _toDisplayString(_ctx.form.type.name), 1),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.type.value) = $event))
          }, [
            _createElementVNode("option", { value: _ctx.interventionType }, _toDisplayString(_ctx.interventionTypeConfig[_ctx.interventionType]?.name), 9, _hoisted_8)
          ], 512), [
            [_vModelSelect, _ctx.form.type.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", null, _toDisplayString(_ctx.form.timeRange.name), 1),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.timeRange.value) = $event))
          }, _hoisted_13, 512), [
            [_vModelSelect, _ctx.form.timeRange.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            ((_ctx.contactUnits.length + _ctx.form.contactOrder.length)<=0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn bg-info btn-sm align-self-center mt-3 mt-xl-0",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToContacts && _ctx.goToContacts(...args)))
                  }, "Jetzt Kontaktpersonen festlegen")
                ]))
              : _createCommentVNode("", true),
            ((_ctx.objectContactPersonIntervention.phone == null))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn bg-info btn-sm align-self-center mt-3 mt-xl-0",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToObjectContact && _ctx.goToObjectContact(...args)))
                  }, "Jetzt Kontaktperson im Objekt festlegen")
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_draggable, {
              list: _ctx.availableContactUnits,
              "item-key": "index",
              tag: "ul",
              class: "media-list media-list-bordered bg-body text-dark p-lg-3",
              group: "people",
              "ghost-class": "sortable-ghost",
              "drag-class": "sortable-drag",
              "chosen-class": "sortable-chosen",
              draggable: ".draggable"
            }, {
              item: _withCtx(({element}) => [
                _createElementVNode("li", {
                  class: _normalizeClass(["media bg-white", (_ctx.shouldDisableSelections() || _ctx.shouldDisableKeine(element) || (_ctx.contactUnits.length<=0 && element === 'contactPerson')) ? 'disabled' : 'draggable'])
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("a", _hoisted_22, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.interventionTypeConfig[_ctx.form.type.value][element]['icon'], "text-blue"])
                      }, null, 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.interventionTypeConfig[_ctx.form.type.value]?.[element]['name']), 1),
                    (element == 'object')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (_ctx.objectContactPersonIntervention.phone && _ctx.objectContactPersonIntervention.firstName)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.objectContactPersonIntervention.firstName) + " " + _toDisplayString(_ctx.objectContactPersonIntervention.lastName) + " | " + _toDisplayString(_ctx.objectContactPersonIntervention.phone), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (element == 'contactPerson')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interventionContacts, (contact, contactIndex) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: contactIndex,
                              class: ""
                            }, _toDisplayString(contactIndex + 1) + ". - " + _toDisplayString(contact.firstName) + " " + _toDisplayString(contact.lastName) + " | " + _toDisplayString(contact.phone), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("a", {
                      class: "btn bg-light",
                      onClick: _withModifiers(($event: any) => (_ctx.checkElement(element)), ["prevent"])
                    }, _hoisted_30, 8, _hoisted_28)
                  ])
                ], 2)
              ]),
              _: 1
            }, 8, ["list"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(_component_draggable, {
              list: _ctx.form.contactOrder,
              "item-key": "index",
              tag: "ul",
              class: "media-list media-list-bordered bg-body text-dark p-lg-3",
              group: "people"
            }, {
              item: _withCtx(({element}) => [
                _createElementVNode("li", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("a", _hoisted_35, [
                      _createElementVNode("i", {
                        class: _normalizeClass([_ctx.interventionTypeConfig[_ctx.form.type.value][element]['icon'], "text-blue"])
                      }, null, 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.interventionTypeConfig[_ctx.form.type.value][element]?.name), 1),
                    (element == 'object')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          (_ctx.objectContactPersonIntervention.firstName && _ctx.objectContactPersonIntervention.phone)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.objectContactPersonIntervention.firstName) + " " + _toDisplayString(_ctx.objectContactPersonIntervention.lastName) + " | " + _toDisplayString(_ctx.objectContactPersonIntervention.phone), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (element == 'contactPerson')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interventionContacts, (contact, contactIndex) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: contactIndex,
                              class: ""
                            }, _toDisplayString(contactIndex + 1) + ". - " + _toDisplayString(contact.firstName) + " " + _toDisplayString(contact.lastName) + " | " + _toDisplayString(contact.phone), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("a", {
                      class: "btn bg-light",
                      onClick: _withModifiers(($event: any) => (_ctx.removeElement(element)), ["prevent"])
                    }, _hoisted_43, 8, _hoisted_41)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["list"])
          ])
        ])
      ]),
      (_ctx.shouldDisableInterventionChanges())
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveIntervention(false)))
            }, "Intervention speichern")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}